<script setup>
import ConfettiExplosion from "vue-confetti-explosion";
import {ref, defineExpose, nextTick, defineProps} from "vue";

const props = defineProps({
   target:{ type: String, required: false, default: 'kt_modal_1' }
});

const showConfetti = ref(false)

const open = async () => {
    // play ack.aac sound
    const audio = new Audio("/media/ack3.aac");
    audio.volume = 0.3;
    audio.play();

    const button = document.createElement("button");
    button.setAttribute("data-bs-toggle", "modal");
    button.setAttribute("data-bs-target", `#${props.target}`);
    document.body.appendChild(button);
    button.click();
    document.body.removeChild(button);
    showConfetti.value = false;
    await nextTick();
    setTimeout(() => {
        showConfetti.value = true;
    }, 300);
}

defineExpose({
    open
})
</script>

<template>
    <div class="modal fade" tabindex="-1" :id="target" style="height: 100vh;">
        <div class="d-flex justify-content-center">
            <ConfettiExplosion v-if="showConfetti"/>
        </div>
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <slot name="header"></slot>
                </div>

                <div class="modal-body">
                    <slot name="body"></slot>
                </div>

                <div v-if="$slots.footer" class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
